import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from '@app/app-config.service';
import { AppStore } from '@app/app.store';
import { ErrorHandlerService } from '@app/core/services/error-handler/error-handler.service';
import { ImporterResults } from '@app/features/exportimport/shared/import-interface';
import { FileTypeExcel } from '@app/shared/models/file.interface';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { ImportTitles } from 'src/assets/features/import-steps/import-titles';
import { DialogService } from '../dialog/dialog.service';
import { SnackbarService } from '../snackbar/snackbar.service';
@Injectable({
  providedIn: 'root'
})
export class ImporterService {
  constructor(
    protected http: HttpClient,
    protected errorHandler: ErrorHandlerService,
    protected appStore: AppStore,
    protected dialogService: DialogService,
    protected translateService: TranslateService,
    protected snackBarService: SnackbarService,
    private appConfigService: AppConfigService
  ) {}

  /**
   * Perform the request to import a file
   *
   * @param type the type
   * @param moduleName module (aka lego)
   * @param file file upload instance
   * @return an Observable
   */
  importFileRequest(type: string, moduleName: string, file: any): Observable<ImporterResults> {
    return this.http.post<ImporterResults>(`${this.appConfigService.getApi()}/importer/importFile/`, {
      type: type,
      fileId: file.id,
      moduleName: moduleName
    });
  }

  /**
   * Resolve import type and its parameters
   * @param type the type
   */
  resolveImportType(type: string): void {
    this.importFile(type, FileTypeExcel.XLSX);
  }

  /**
   * Import file
   *
   * @param type a value that identifies a flow that can handle the request (e.g. impdevices, impusers, etc.)
   * @param title the dialog title
   * @param stepsComponent
   * @param templateType optional parameter that indicates that a template is available (null if not)
   */
  importFile(type: string, templateType?: string) {
    const title = this.translateService.instant(ImportTitles[type]);
    this.dialogService
      .importData(type, templateType, this.appConfigService.getHelpImportData() + '/' + type)
      .subscribe(res => {
        if (!res.cancel && res.file) {
          this.importFileRequest(res.type, title, res.file).subscribe(result => {
            if (result.success) {
              //Show an snackbar indicating that the flow has started
              this.snackBarService.openSnackBar(
                this.translateService.instant('core.general.importStarted.snackbar', {
                  value: this.translateService.instant(title)
                }),
                'snackbar'
              );
            } else if (result.errorMessage) {
              this.snackBarService.openSnackBar(this.translateService.instant(result.errorMessage), 'warning');
            } else {
              this.snackBarService.openSnackBar(this.translateService.instant('core.general.genericError'), 'warning');
            }
          });
        }
      });
  }

  getImportTypeTitle(type: string): string {
    return;
  }
}
